import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Btn, Input, Field } from "@/components/common";
import { apiError } from "@/lib/api";

function AuthShell({ title, sub, children }) {
  return (
    <div className="min-h-screen flex" style={{ background: "var(--si-bg)" }}>
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden" style={{ width: "42%", borderRight: "1px solid var(--si-border)" }}>
        <div className="absolute inset-0 si-grain" />
        <Link to="/" className="font-display text-xl relative" style={{ color: "var(--si-text)" }}>Strategic Interest</Link>
        <div className="relative">
          <div className="font-mono text-sm mb-4" style={{ color: "var(--si-teal-light)" }}>// SPIDER CONTACT</div>
          <p className="text-2xl font-display leading-snug" style={{ color: "var(--si-silver)" }}>
            Map the network around any point of origin.
          </p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden font-display text-xl mb-8" style={{ color: "var(--si-text)" }}>Strategic Interest</div>
          <h1 className="text-2xl font-medium" style={{ color: "var(--si-text)" }}>{title}</h1>
          <p className="text-sm mt-1 mb-8" style={{ color: "var(--si-text-2)" }}>{sub}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      navigate("/app");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Sign in" sub="Enter your workspace.">
      <form onSubmit={submit}>
        <Field label="Email"><Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" /></Field>
        <Field label="Password"><Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" /></Field>
        <Btn data-testid="login-submit" type="submit" variant="primary" className="w-full" disabled={loading}>{loading ? "Signing in…" : "Sign in"}</Btn>
      </form>
      <div className="flex justify-between mt-5 text-sm">
        <Link to="/forgot-password" data-testid="forgot-link" style={{ color: "var(--si-text-2)" }}>Forgot password?</Link>
        <Link to="/register" style={{ color: "var(--si-silver)" }}>Create account</Link>
      </div>
    </AuthShell>
  );
}

export { AuthShell };
